import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class Loading extends React.PureComponent {
    static propTypes = {
        handleLoadingHide: PropTypes.func,
        handleDataInit: PropTypes.func,
    };

    state = {
        isShow: true,
    };

    componentDidMount() {
        this.props.handleDataInit();

        /* eslint-disable no-undef */
        TweenLite.fromTo(
            '#progress',
            1,
            { width: 0 },
            {
                width: '75%',
                onComplete: () => {
                    TweenLite.fromTo(
                        '#progress',
                        0.5,
                        { width: '75%' },
                        {
                            width: '100%',
                            onComplete: () => {
                                TweenLite.fromTo(
                                    '#loading',
                                    0.5,
                                    { opacity: 1 },
                                    {
                                        opacity: 0,
                                        onComplete: () => {
                                            this.setState(
                                                {
                                                    isShow: false,
                                                },
                                                () => {
                                                    this.props.handleLoadingHide();
                                                },
                                            );
                                        },
                                    },
                                );
                            },
                        },
                    );
                },
            },
        );
        /* eslint-enable no-undef */
    }

    render() {
        const { isShow } = this.state;

        return isShow ? (
            <div
                id="loading"
                className={styles.loading}
                style={{ width: window.innerWidth, height: window.innerHeight }}>
                <span className={styles.logo} />
                <div className={styles.progress_box}>
                    <div id="progress" className={styles.progress} />
                </div>
                <span className={styles.txt}>loading...</span>
            </div>
        ) : (
            <div />
        );
    }
}

export default errorBoundary(Loading);
